<!-- eslint-disable vue/max-len -->
<template>
  <svg
    :class="`color-stroke-${color}`"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9 11V21C9 21.5523 9.44772 22 10 22H14C14.5523 22 15 21.5523 15 21V11"
      stroke-linecap="round"
    />
    <path d="M12 15V22" stroke-linecap="round" />
    <path
      d="M9.5 15H9C7.89543 15 7 14.1046 7 13V9C7 7.89543 7.89543 7 9 7H15C16.1046 7 17 7.89543 17 9V13C17 14.1046 16.1046 15 15 15H14.5"
    />
    <path
      d="M10 3C10 2.17157 10.6716 1.5 11.5 1.5H12.5C13.3284 1.5 14 2.17157 14 3V4C14 4.82843 13.3284 5.5 12.5 5.5H11.5C10.6716 5.5 10 4.82843 10 4V3Z"
    />
  </svg>
</template>

<script setup lang="ts">
interface icon {
  color?: string;
}

withDefaults(defineProps<icon>(), {
  color: 'dodger-blue',
});
</script>
